<template>
  <!-- 撮合发票管理 -> 开票订单详情 -> 任务信息 -->
  <div class="base-card-info">
    <div class="info-card-title">
      任务信息
    </div>

    <div class="custom-base-info">
      <!-- 任务名称 -->
      <div class="item">
        <div class="label">
          任务名称
        </div>
        <div class="value">
          {{ duty.dutyName || '--' }}
        </div>
      </div>
      <!-- 订单编号 -->
      <div class="item">
        <div class="label">
          订单编号
        </div>
        <div class="value">
          {{ duty.orderNo || '--' }}
        </div>
      </div>
      <!-- 订单状态 -->
      <div class="item">
        <div class="label">
          订单状态
        </div>
        <div class="value">
          <custom-tag
            v-if="!isNull(duty.orderStatus)"
            class="!justify-start"
            :type="orderStatus"
            :label="settlementStatusLabel[duty.orderStatus]"
          />
          <span v-else>
            --
          </span>
        </div>
      </div>
      <!-- 服务主体 -->
      <div class="item">
        <div class="label">
          服务主体
        </div>
        <div class="value">
          {{ duty.serverName || '--' }}
        </div>
      </div>
      <!-- 发票类型 -->
      <div class="item">
        <div class="label">
          发票类型
        </div>
        <div class="value">
          {{ duty.invoiceTypeStr || '--' }}
        </div>
      </div>
      <!-- 任务类型 -->
      <div class="item">
        <div class="label">
          任务类型
        </div>
        <div class="value">
          {{ duty.dutyTempName || '--' }}
        </div>
      </div>
      <!-- 订单开始时间 -->
      <div class="item">
        <div class="label">
          订单开始时间
        </div>
        <div class="value">
          {{ duty.startTime || '--' }}
        </div>
      </div>
      <!-- 订单结束时间 -->
      <div class="item">
        <div class="label">
          订单结束时间
        </div>
        <div class="value">
          {{ duty.endTime || '--' }}
        </div>
      </div>
      <!-- 开票科目 -->
      <div class="item">
        <div class="label">
          开票科目
        </div>
        <div class="value">
          {{ duty.invoiceSubName || '--' }}
        </div>
      </div>
      <!-- 支付通道 -->
      <div class="item">
        <div class="label">
          支付通道
        </div>
        <div class="value">
          {{ paymentChannelLabel[duty.payType] || '--' }}
        </div>
      </div>
      <!-- 空盒子 -->
      <div class="item">
        <div class="label">
          &nbsp;
        </div>
        <div class="value">
          &nbsp;
        </div>
      </div>
    </div>

    <div class="custom-base-info pt-3">
      <!-- 结算说明 -->
      <div class="item">
        <div class="label">
          结算说明
        </div>
        <div class="value !max-w-[760px]">
          {{ duty.remark || '--' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { isNull } from '@core/tools';
import { CustomTag } from '@vue3/components';
import { computed, PropType } from 'vue';
import { ISettlementOrderDuty, paymentChannelLabel, settlementStatusLabel, settlementStatusStyle } from '@core/main/types';

const props = defineProps({
  duty: {
    type: Object as PropType<ISettlementOrderDuty>,
    required: true,
  },
});

const orderStatus = computed(() => settlementStatusStyle[props.duty.orderStatus] as any);
</script>

<style lang="scss" scoped src="./index.scss" />
